import { BodyText, Headline, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { EmptyResultsImage } from './empty-results-image';
import * as Styles from './empty-results-placeholder.module.less';

export interface EmptyResultsPlaceholderProps {
    className?: string;
    size?: 'small' | 'medium';
    title: string;
    description?: string;
    children?: ReactNode;
}

export const EmptyResultsPlaceholder: FC<EmptyResultsPlaceholderProps> = ({
    children,
    className,
    description,
    size = 'medium',
    title,
}) => (
    <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classNames('flex-grow-1 flex-basis-0', className)}
    >
        <EmptyResultsImage className={classNames({ [Styles.emptyImageSmall]: size === 'small' })} />

        <Headline className="m-t-2 m-b-half" size={size}>
            {title}
        </Headline>

        {!!description && (
            <BodyText className="ta-center" size="xsmall" subdued>
                {description}
            </BodyText>
        )}

        {children}
    </Stack>
);
